import { Badge, BadgeProps } from "antd";
import { PresetStatusColorType } from "antd/es/_util/colors";
import { FC, useMemo } from "react";
import { useAppGlobStore } from "src/appGlobalStore";
import { GLOB } from "src/util/Glob";

export const XmWarningBadge: FC<BadgeProps & { hostcfg: boolean; license: boolean; certificate: boolean; }> = ({ hostcfg, license, certificate, ...props }) => {

  const licenseStatus = useAppGlobStore(s => s.licenseStatus);
  const validTo = useAppGlobStore(s => s.info.backend.cert.validTo);

  const status = useMemo(() => {
    const statuses: PresetStatusColorType[] = [];

    if (license)
      statuses.push(licenseStatus);

    if (certificate && GLOB.isCertificateEnding()) {
      statuses.push('warning');
    }

    return statuses?.reduce((prev, cur) => prev === 'error' ? prev
      : cur === 'error' ? cur
        : prev === 'warning' ? prev
          : cur, 'default');
  }, [licenseStatus, validTo]);

  return GLOB.userInfo.isAdmin ? <Badge status={status} dot={status !== 'default'}
    //title={status === 'error' ? "Your license has expired!" : "Your license will expire soon!"}
    {...props} />
    : <>{props.children}</>;
};